const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		type: 1,
		content: '',
		// 荣誉
		honorList: [
            {
                img: 'images/honor5.jpg',
                title: '2020年荣获央视网-社会责任教育集团',
                isActive: false
            },
            {
                img: 'images/honor4.jpg',
                title: '2020年荣获新华网-年度影响力在线教育品牌',
                isActive: false
            },
            {
                img: 'images/6e0b34fd3b90a4ff4b7cca45cf3829b.jpg',
                title: '2019年荣获网易-金翼奖-品牌影响力在线教育机构',
                isActive: true
            },
            {
                img: 'images/honor1.jpg',
                title: '2018年荣获中国网-好教育-品牌影响力教育集团',
                isActive: false
            },
            {
                img: 'images/honor2.jpg',
                title: '2018年荣获腾讯网-回响中国-社会信赖职业教育品牌',
                isActive: false
            },
            {
                img: 'images/honor3.jpg',
                title: '2018年荣获国家AAA级信用企业',
                isActive: false
            },
		],
	},
	methods: {
		getParams() {
			this.type = this.getQueryString('type') || 1;
		},
		getInfo() {
			axios.post(baseURL + 'getCompany?type=' + this.type)
				.then(res => {
					if (res.code == 200) {
						if (res.list[0]) {
							this.content = res.list[0].content;
						}
					}
				})
				.catch(err => console.log(err));
		},
		changeTab(type) {
			location.href = base + 'pages/about/about.html?type=' + type;
		},
		// 切换荣誉
		changeHonor(honor) {
			this.honorList.forEach(item => item.isActive = false);
			honor.isActive = true;
		},
		// 荣誉轮播
		slideHonor() {
			let index = 0;
			setInterval(() => {
				index == 2 ? index = 0 : index++;
				this.honorList.forEach(item => item.isActive = false);
				this.honorList[index].isActive = true;
			}, 3000);
		}
	},
	created() {
		this.getParams();
		this.getInfo();
		this.slideHonor();
	}
});